import React, { Component } from 'react';
import config from 'react-global-configuration';

// Importação do Router
import {Redirect} from 'react-router-dom';
// Importação do Bootstrap
import { ButtonToolbar, Dropdown, MenuItem } from 'react-bootstrap';
// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import Loading from '../../Miscelania/Loading';
import Alerta from '../../Miscelania/Alerta';
import RequestApi from '../../Miscelania/RequestApi';
import DatePicker from 'react-bootstrap-date-picker';

class TeamsEditTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      training_numbers_sigtrip_load: 0,
      training_numbers_sigmec_load: 0,
      id: this.props.team_id,     
      name: this.props.team_data.name,
      date_start_str: this.props.team_data.date_start_str,
      date_finish_str: this.props.team_data.date_finish_str,
      location: this.props.team_data.location,
      observation: this.props.team_data.observation,
      presence: this.props.team_data.presence,
      type: this.props.team_data.type,
      payment_status: this.props.team_data.payment_status,
      status: this.props.team_data.status,
      training_id: this.props.team_data.training_id,
      report_dangerous_articles: this.props.team_data.report_dangerous_articles,
      sigtrip_treinamentos_lista: this.props.sigtrip_treinamentos_lista,
      sigmec_treinamentos_lista: this.props.sigmec_treinamentos_lista,
      status_txt: '',
      troca_index: '',
      classe_status: null,
      troca: '',
      lista_treinamentos: [],
      sigtrip_selected_list: [],
      sigmec_selected_list: [],
    };
    this.editar = this.editar.bind(this);
    this.trocar_status = this.trocar_status.bind(this);
    this.handleChangeDateStartPicker = this.handleChangeDateStartPicker.bind(this);
    this.handleChangeDateFinishPicker = this.handleChangeDateFinishPicker.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleSelectChangeTrainingNumber(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }
  handleChangeDateStartPicker(value, formattedValue) {
    this.setState({
      date_start: value,
      date_start_str: formattedValue,
    });
  }
  handleChangeDateFinishPicker(value, formattedValue) {
    this.setState({
      date_finish: value,
      date_finish_str: formattedValue,
    });
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.lista_treinamentos)) {
      this.setState({lista_treinamentos: newProps.lista_treinamentos});
    }
    if(Array.isArray(newProps.sigtrip_treinamentos_lista)) {
      this.setState({sigtrip_treinamentos_lista: newProps.sigtrip_treinamentos_lista});
    }
    if(Array.isArray(newProps.sigmec_treinamentos_lista)) {
      this.setState({sigmec_treinamentos_lista: newProps.sigmec_treinamentos_lista});
    }
    if(Array.isArray(newProps.sigtrip_selected_list) && this.state.training_numbers_sigtrip_load == 0) {
      this.setState({sigtrip_selected_list: newProps.sigtrip_selected_list});
      this.setState({training_numbers_sigtrip_load: 1});
    }
    if(Array.isArray(newProps.sigmec_selected_list) && this.state.training_numbers_sigmec_load == 0) {
      this.setState({sigmec_selected_list: newProps.sigmec_selected_list});
      this.setState({training_numbers_sigmec_load: 1});
    }
    if(typeof this.state.name === 'undefined') {
      this.setState({
        id: newProps.team_id,
        name: newProps.team_data.name,
        date_start_str: newProps.team_data.date_start_str,
        date_finish_str: newProps.team_data.date_finish_str,
        date_start: newProps.team_data.date_start,
        date_finish: newProps.team_data.date_finish,
        location: newProps.team_data.location,
        observation: newProps.team_data.observation,
        presence: newProps.team_data.presence,
        type: newProps.team_data.type,
        payment_status: newProps.team_data.payment_status,
        training_id: newProps.team_data.training_id,
        report_dangerous_articles: newProps.team_data.report_dangerous_articles,
        status: newProps.team_data.status,
      });
      if(newProps.team_data.status == 'previsto') {
        this.setState({status_txt: 'Previsto', troca_index: 'finalizado', class_status: '',  troca: 'Trocar para finalizado'});
      } else if(newProps.team_data.status == 'finalizado') {
        this.setState({status_txt: 'Finalizado', troca_index: 'cancelado', class_status: '',  troca: 'Trocar para cancelado'});
      } else if(newProps.team_data.status == 'cancelado') {
        this.setState({status_txt: 'Cancelado', troca_index: 'cancelado', class_status: '',  troca: ''});
      }
    }
  }
  
  // Fetch salvando a edição
  editar(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      name: this.state.name,
      date_start: this.state.date_start_str,
      date_finish: this.state.date_finish_str,
      location: this.state.location,
      observation: this.state.observation,
      presence: this.state.presence,
      type: this.state.type,
      payment_status: this.state.payment_status,
      training_id: this.state.training_id,
      status: this.state.status,
      report_dangerous_articles: this.state.report_dangerous_articles,
      sigtrip_training_ids: this.state.sigtrip_selected_list,
      sigmec_training_ids: this.state.sigmec_selected_list,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/turma', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // fetch realizando a troca de instrução
  trocar_status (troca) {
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      status: troca,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/turma/trocar_status', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({status: troca});
          if(troca == 'finalizado') {
            self.setState({status_txt: 'Finalizado', troca_index: 'cancelado', classe_status: '',  troca: 'Trocar para Cancelado'});
          } else if(troca == 'cancelado'){
            var url = '/turmas';
            var storage = {
              alert_message: responseJson.message,
              alert_type: responseJson.status,
            };
            localStorage.setItem("verify_message", JSON.stringify(storage));
            self.setState({redirect_url: url});
          } 
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <h3 className="page-title">Cadastro da turma</h3>
  <hr/>
  <form onSubmit={this.editar}>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Nome da turma:</label>
          <input required type="text" name="name" className="form-control" placeholder="Nome da turma" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>Localidade:</label>
          <input required type="text" name="location" className="form-control" placeholder="Localidade" value={this.state.location} onChange={this.handleChange.bind(this, 'location')} />
        </div>
      </div>
    </div>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>Data de início:</label>
            <DatePicker onChange={this.handleChangeDateStartPicker} monthLabels={['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']} dayLabels={['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']} dateFormat={'DD/MM/YYYY'} placeholder="Data de início" value={this.state.date_start} />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>Data de término:</label>
            <DatePicker onChange={this.handleChangeDateFinishPicker} monthLabels={['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']} dayLabels={['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']} dateFormat={'DD/MM/YYYY'} placeholder="Data de término" value={this.state.date_finish} />
          </div>
        </div>
      </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Tipo de presença:</label>
          <Select
            className="form-field-name"
            name="presence"
            value={this.state.presence}
            searchable={true}
            required
            placeholder={'Selecione o tipo de presença'}
            onChange={this.handleSelectChange.bind(this, 'presence')}
            options={[
              {value: "presencial", label: "Presencial"},
              {value: "ead", label: "EAD"},
              {value: "semipresencial", label: "Semipresencial"},
            ]}
          />    
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>Público:</label>
          <Select
            className="form-field-name"
            name="type"
            value={this.state.type}
            searchable={true}
            required
            placeholder={'Selecione o público'}
            onChange={this.handleSelectChange.bind(this, 'type')}
            options={[
              {value: "interna", label: "Interna"},
              {value: "externa", label: "Externa"},
              {value: "mista", label: "Mista"},
            ]}
          />    
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Número de Comunicação de Treinamento SIGTRIP:</label>
          <Select
            className="form-field-name"
            name="sigtrip_selected_list"
            value={this.state.sigtrip_selected_list}
            searchable={true}
            multi={true}
            placeholder={'Selecione os números de comunicado'}
            onChange={this.handleSelectChangeTrainingNumber.bind(this, 'sigtrip_selected_list')}
            options={this.state.sigtrip_treinamentos_lista}
          />    
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>Número de Comunicação de Treinamento SIGMEC:</label>
          <Select
            className="form-field-name"
            name="sigmec_selected_list"
            value={this.state.sigmec_selected_list}
            searchable={true}
            multi={true}
            placeholder={'Selecione os números de comunicado'}
            onChange={this.handleSelectChangeTrainingNumber.bind(this, 'sigmec_selected_list')}
            options={this.state.sigmec_treinamentos_lista}
          />    
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>Status do pagamento:</label>
          <Select
            className="form-field-name"
            name="payment_status"
            value={this.state.payment_status}
            searchable={true}
            required
            placeholder={'Selecione o status do pagamento'}
            onChange={this.handleSelectChange.bind(this, 'payment_status')}
            options={[
              {value: "nao_cobrado", label: "Não cobrado"},
              {value: "nao_aplicavel", label: "Não Aplicável"},
              {value: "cobrado", label: "Cobrado"},
              {value: "pago", label: "Pago"},
            ]}
          />    
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Treinamentos:</label>
            <Select
              disabled={true}
              className="form-field-name"
              name="training_id"
              value={this.state.training_id}
              searchable={true}
              placeholder={'Selecionar Treinamento'}
              options={this.state.lista_treinamentos}
            />    
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>Relatório de artigos perigosos:</label>
          <Select
            className="form-field-name"
            name="report_dangerous_articles"
            value={this.state.report_dangerous_articles}
            searchable={true}
            required
            placeholder={'Selecione uma opção'}
            onChange={this.handleSelectChange.bind(this, 'report_dangerous_articles')}
            options={[
              {value: "nao_aplicavel", label: "Não Aplicável"},
              {value: "enviado", label: "Enviado"},
              {value: "nao_enviado", label: "Não Enviado"},
              {value: "obrigatorio", label: "Obrigatório"},
            ]}
          />    
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-12">
        <div className="form-group">
          <label>Observações:</label>
          <textarea style={{ height: 200 }} type="text" name="observation" className="form-control" value={this.state.observation} onChange={this.handleChange.bind(this, 'observation')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <ButtonToolbar>
          <button onClick={this.editar} className="btn btn-primary"><i className="fa fa-fw fa-save"></i> Salvar edição</button>
          <Dropdown id="trocar-status">
            <Dropdown.Toggle bsStyle={this.state.classe_status}>
              <i className="fa fa-fw fa-user"></i> {this.state.status_txt}
            </Dropdown.Toggle>
            {this.state.status_txt === "Previsto" ? <Dropdown.Menu><MenuItem eventKey={"finalizado"} onSelect={this.trocar_status}>{'Trocar para finalizado'}</MenuItem><MenuItem eventKey={"cancelado"} onSelect={this.trocar_status}>{"Trocar para cancelado"}</MenuItem></Dropdown.Menu> : <Dropdown.Menu><MenuItem eventKey={this.state.troca_index} onSelect={this.trocar_status}>{this.state.troca}</MenuItem></Dropdown.Menu>}
          </Dropdown>
        </ButtonToolbar>
      </div>
    </div>
  </form>
</div>
    );
  }
}

export default TeamsEditTab;



// WEBPACK FOOTER //
// ./src/Components/Teams/Elements/TeamsEditTab.js